<template>
  <div class="dashboard-page">
    <h1 class="page-title">Dashboard Pengendalian</h1>
    <div class="sidesWrapper">
      <div style="width: 100%">
        <b-tabs nav-class="bg-transparent">
          <b-tab title="Pengendalian" active>
            <div class="d-inline-block">
              <select
                v-model="filter_tahun"
                id="filter_tahun1"
                class="form-select"
              >
                <option v-for="d in optionTahun" :value="d">{{ d }}</option>
              </select>
            </div>

            <div class="row mt-2 g-3">
              <div class="col-12 col-lg-4">
                <div class="px-3 pt-3 shadow rounded-1">
                  <div class="d-flex align-items-center">
                    <span class="widget-icon me-3" style="height: auto">
                      <i class="fa fa-bar-chart text-primary" />
                    </span>
                    <h3 class="m-0">Jumlah Laporan Tahunan</h3>
                  </div>
                  <p class="fs-1">999</p>
                  <div class="row g-0 pb-3">
                    <div class="col-6">
                      <h5 class="m-0">999</h5>
                      <p class="text-secondary m-lg-0">Berusaha</p>
                    </div>
                    <div class="col-6">
                      <h5 class="m-0">999</h5>
                      <p class="text-secondary m-lg-0">Nonberusaha</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4 pt-4">
              <div class="col-12 col-lg-6 col-xl-3 mb-4">
                <div
                  class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
                  style="height: 100%"
                >
                  <div class="d-flex align-items-center">
                    <span class="widget-icon me-3" style="height: auto">
                      <i class="fa fa-hourglass-2 text-primary" />
                    </span>
                    <h3 class="m-0">Laporan Belum Diverifikasi</h3>
                  </div>
                  <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">999</p>
                </div>
              </div>
              <div class="col-12 col-lg-6 col-xl-3 mb-4">
                <div
                  class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
                  style="height: 100%"
                >
                  <div class="d-flex align-items-center">
                    <span class="widget-icon me-3" style="height: auto">
                      <i class="fa fa-file-text-o text-primary" />
                    </span>
                    <h3 class="m-0">Laporan Sudah Diterima</h3>
                  </div>
                  <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">999</p>
                </div>
              </div>
              <div class="col-12 col-lg-6 col-xl-3 mb-4">
                <div
                  class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
                  style="height: 100%"
                >
                  <div class="d-flex align-items-center">
                    <span class="widget-icon me-3" style="height: auto">
                      <i class="fa fa-search text-primary" />
                    </span>
                    <h3 class="m-0">Dalam Proses Penilaian</h3>
                  </div>
                  <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">999</p>
                </div>
              </div>
              <div class="col-12 col-lg-6 col-xl-3 mb-4">
                <div
                  class="shadow rounded-1 p-3 d-flex flex-column justify-content-between"
                  style="height: 100%"
                >
                  <div class="d-flex align-items-center">
                    <span class="widget-icon me-3" style="height: auto">
                      <i class="fa fa-check-square text-primary" />
                    </span>
                    <h3 class="m-0">Selesai</h3>
                  </div>
                  <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">999</p>
                </div>
              </div>
            </div>

            <div class="row mt-4 pt-2">
              <div class="col-xl-6">
                <StatusPenyampaianChart :tahun="filter_tahun" />
              </div>
              <div class="col-xl-6">
                <HasilPenilaianChart :tahun="filter_tahun" />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import HasilPenilaianChart from './components/Pengendalian/HasilPenilaianChart.vue'
import StatusPenyampaianChart from './components/Pengendalian/StatusPenyampaianChart.vue'
const option_bulan = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Mei',
  'Jun',
  'Jul',
  'Agu',
  'Sep',
  'Okt',
  'Nov',
  'Des',
]

export default {
  components: {
    StatusPenyampaianChart,
    HasilPenilaianChart,
  },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      optionBulan: [...option_bulan],
      filter_tahun: new Date().getFullYear(),
    }
  },
  methods: {},
  computed: {
    optionTahun() {
      const currentYear = new Date().getFullYear()
      return Array.from({ length: 10 }, (_, i) => currentYear - i)
    },
  },
  watch: {
    filter_tahun: {
      async handler() {
        await this.loadDataPermohonan()
        await this.loadDataPenerbitan()
        await this.loadCapaianPNBP()
      },
      immediate: true,
    },
  },
}
</script>

<style src="./Dashboard.scss" lang="scss" />

<style scoped>
.h-auto {
  height: auto !important;
}

@media (min-width: 1200px) {
  .h-auto {
    height: 100% !important;
  }
}
</style>
